import {
	AssuredWorkloadOutlined,
	BallotOutlined,
	CalendarMonthOutlined,
	EmojiEventsOutlined,
	InsertChartOutlined,
	LiveTvOutlined,
	NightlifeOutlined,
	PeopleAltOutlined,
  } from "@mui/icons-material";
  import { Box, Grid, Typography } from "@mui/material";
  import React from "react";
  import { Helmet } from "react-helmet";
  // import { Chart } from "react-google-charts";
  import api from "../../../services/Axios"; // ✅ add your axios instance
  import toast from "react-hot-toast"; // ✅ optional (remove if not needed)
  
  export default function Dashboard() {
	const [loading, setLoading] = React.useState(false);
	const [apiError, setApiError] = React.useState("");
  
	const [stats, setStats] = React.useState({
	  totalOrganizer: 0,
	  totalEvents: 0,
	  totalDj: 0,
	  totalRevenue: 0,
	  liveEvents: 0,
	  upcomingEvents: 0,
	  totalVotes: 0,
	  totalPayout: 0,
	  totalTips: 0,
	  totalOrganizerTips:0,
	  totalDjTips:0,
	  totalAdminTips:0
	});
  
	const getAuthHeader = () => ({
	  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
	});
  
	const fetchDashboard = async () => {
	  setLoading(true);
	  setApiError("");
  
	  const header = getAuthHeader();
  
	  const response = await api
		.get(`/dashboard`, header) // ✅ if your baseURL already contains "/api", change this to "/admin/dashboard"
		.then((res) => res)
		.catch((err) => err?.response);
  
	  setLoading(false);
  
	  if (response?.data?.success) {
		const d = response?.data?.data || {};
  
		// ✅ Safe mapping (handles undefined keys)
		setStats({
		  totalOrganizer: d?.totalOrganizer ?? d?.total_organizer ?? 0,
		  totalEvents: d?.totalEventCount ?? d?.totalEventCount ?? 0,
		  totalDj: d?.totalDj ?? d?.total_dj ?? 0,
		  totalRevenue: d?.totalRevenue ?? d?.total_revenue ?? 0,
		  liveEvents: d?.liveEvents ?? d?.liveEvents ?? 0,
		  upcomingEvents: d?.upcomingEvents ?? d?.upcomingEvent ?? 0,
		  totalVotes: d?.totalVotes ?? d?.total_votes ?? 0,
		  totalPayout: d?.payout ?? d?.payout ?? 0,
		  totalTips: d?.totalTips ?? d?.total_tips ?? 0,
		  totalOrganizerTips: d?.totalOrganizerTips ?? d?.total_organizer_tips ?? 0,
		  totalAdminTips: d?.totalAdminTips ?? d?.total_admin_tips ?? 0,
		  totalDjTips: d?.totalDjTips ?? d?.total_dj_tips ?? 0,
		});
	  } else {
		const msg = response?.data?.message || "Something went wrong";
		setApiError(msg);
		// toast.error(msg); // optional
	  }
	};
  
	React.useEffect(() => {
	  fetchDashboard();
	}, []);
  
	return (
	  <>
		{/* <Helmet>
		  <title> Dashboard</title>
		</Helmet> */}
  
		<div className="dashboard-main">
		  <Box maxWidth={1600} mx={"auto"}>
			<Box className="title" mb={2}>
			  <div className="left">
				<h3>Dashboard</h3>
			  </div>
			</Box>
  
			{/* ✅ Loading + Error */}
			{apiError && (
			  <Typography sx={{ color: "red", mb: 2 }}>{apiError}</Typography>
			)}
			{loading && (
			  <Typography sx={{ color: "white", mb: 2 }}>{"...Loading "}</Typography>
			)}
  
			<Grid container spacing={2}>
			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Total organizer</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats.totalOrganizer}
					  </Typography>
					</Grid>
					<Grid item>
					  <PeopleAltOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>
  
			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Total Events</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats.totalEvents}
					  </Typography>
					</Grid>
					<Grid item>
					  <EmojiEventsOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>
  
			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Total Dj</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats.totalDj}
					  </Typography>
					</Grid>
					<Grid item>
					  <NightlifeOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>
  
			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Total Revenue</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats.totalRevenue}
					  </Typography>
					</Grid>
					<Grid item>
					  <InsertChartOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>
  
			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Live Events</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats.liveEvents}
					  </Typography>
					</Grid>
					<Grid item>
					  <LiveTvOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>
  
			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Upcoming Event</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats.upcomingEvents}
					  </Typography>
					</Grid>
					<Grid item>
					  <CalendarMonthOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>
  
			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Total Vote</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats.totalVotes}
					  </Typography>
					</Grid>
					<Grid item>
					  <BallotOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>
  
			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Total Payout</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats.totalPayout}
					  </Typography>
					</Grid>
					<Grid item>
					  <AssuredWorkloadOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>

			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Total Tips</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats?.totalTips}
					  </Typography>
					</Grid>
					<Grid item>
					  <AssuredWorkloadOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>

			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Total Dj Tips</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats?.totalDjTips}
					  </Typography>
					</Grid>
					<Grid item>
					  <AssuredWorkloadOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>

			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Total Organizer Tips</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats?.totalOrganizerTips}
					  </Typography>
					</Grid>
					<Grid item>
					  <AssuredWorkloadOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>

			  <Grid item xs={12} sm={4} md={3}>
				<Box borderRadius={2} p={2} sx={{ backgroundColor: "#112E55" }}>
				  <Grid item container justifyContent={"space-between"} alignItems={"center"}>
					<Grid item>
					  <Typography color={"#fff"}>Total Admin Tips</Typography>
					  <Typography fontSize={40} color={"#fff"} fontWeight={600}>
						{stats?.totalAdminTips}
					  </Typography>
					</Grid>
					<Grid item>
					  <AssuredWorkloadOutlined sx={{ fontSize: 50, color: "#fff" }} />
					</Grid>
				  </Grid>
				</Box>
			  </Grid>

			</Grid>
  
			{/* If you want chart using API data, share response keys for timeseries. */}
		  </Box>
		</div>
	  </>
	);
  }
  